import React from "react";
import { Checkbox } from "@/components/ui/checkbox";

// The ONE checkbox group behind every admin surface that ties catalogue services to
// opening hours: DayWindowsRow (per weekly window), WeeklyScheduleEditor (the
// template-level default) and ExtraHoursDialog (hours on one date).
//
// Any combination is legal. A window offers a SET of services and the client picks one
// of them BEFORE any time is shown, so each service's start times carry only that
// service's own length and money contract (open-hours decision E retired the old
// "a per-minute consultation may not share a block" rule, which existed only because a
// pre-built slot had to advertise one contract on one tile).
export const ServiceCheckboxGroup = ({ services, selectedIds, onChange, renderLabel, idPrefix }) => {
  const toggle = (id, checked) => {
    onChange(checked ? [...selectedIds, id] : selectedIds.filter((x) => x !== id));
  };

  return (
    <div className="space-y-1" data-testid={idPrefix}>
      {services.map((s) => (
        <label key={s.id} className="flex items-center gap-2 text-xs cursor-pointer">
          <Checkbox
            checked={selectedIds.includes(s.id)}
            onCheckedChange={(v) => toggle(s.id, !!v)}
            data-testid={`${idPrefix}-${s.id}`}
          />
          <span>{renderLabel ? renderLabel(s) : s.name}</span>
        </label>
      ))}
    </div>
  );
};
